<div class="kz-modal-infos">
    <div class="kz-modal-header">
      <h2>✨ Sauvegardez votre Kaza en quelques clics</h2>
    </div>
    <div class="kz-modal-body">
      <p>
        Vous tenez à garder une trace de votre aventure sur Kozikaza ? Pas de souci, on vous explique comment enregistrer votre contenu en quelques étapes simples.
      </p>
      <div class="kz-steps">
        <div class="kz-step">
          <span class="kz-step-number">1️⃣</span>
          <p>Fermez cette fenêtre</p>
        </div>
        <div class="kz-step">
          <span class="kz-step-number">2️⃣</span>
          <p>Cliquez sur la petite horloge en haut à droite de votre contenu pour trier vos posts du plus ancien au plus récent.</p>
        </div>
        <div class="kz-step">
          <span class="kz-step-number">3️⃣</span>
          <p>Faites défiler la page jusqu’en bas pour charger l’ensemble de vos posts (continuez jusqu’à ce qu’il n’y ait plus rien à afficher).</p>
        </div>
        <div class="kz-step">
          <span class="kz-step-number">4️⃣</span>
          <p>Re-cliquez sur le bouton "Sauvegarde de ma kaza" puis sélectionnez "Sauvegarder le contenu de ma kaza (les posts)".</p>
        </div>
        <div class="kz-step">
          <span class="kz-step-number">5️⃣</span>
          <p>Patientez quelques instants, laissez la capture se faire sans quitter la page.</p>
        </div>
        <div class="kz-step">
          <span class="kz-step-number">6️⃣</span>
          <p>Votre Kaza sera automatiquement enregistrée dans votre dossier Téléchargements ! 🎉</p>
        </div>
      </div>
      <p class="kz-modal-footer">
        C’est tout ! Vous pourrez ainsi conserver tous vos précieux souvenirs de votre aventure déco & maison. 🏡✨
        <br />
        On reste là si besoin, et merci d’avoir fait partie de l’aventure Kozikaza ! 💙
      </p>
    </div>
  </div>